import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
import ErrorWithCause from '@helpers/ErrorWithCause';
const getGameModes = async (gameKey) => {
    try {
        const { data } = await axios.get(`${SYMFONY_API_BASE_URL}/api/gamemode/v1`, {
            params: {
                gameKey,
            },
        });
        return data;
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getGameModes;
